import logo from "./redIcon.png";
import './App.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";

import Footer from "./Footer";

import { useState, useEffect, useRef } from 'react';

import { firestore, auth, storage } from "./firebase";
import { collection, doc, getDoc } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

signInWithEmailAndPassword(auth, "scottymart07@gmail.com", process.env.PASSWORD);

let cache = [];

function TagButton(props) {
  if (props.tag === "") return <div></div>;
  else {
    return (
      <button className="bg-ddg mt-5 mx-10 lg:mr-5 lg:ml-0 px-16 py-1 rounded-lg text-base">{props.tag}</button>
    )
  }
}

function StatusButton(props) {
  let button;
  if (props.status === "Complete") button = <button className="bg-ddc mx-10 lg:ml-20 mt-5 px-20 py-1 rounded-lg text-base">{props.status}</button>;
  else if (props.status === "Demo") button = <button className="bg-ddy mx-10 lg:ml-20 mt-5 px-10 py-1 rounded-lg text-base">{props.status}</button>;
  else button = <button className="bg-ddo mx-10 lg:ml-20 lg:ml-20 mt-5 px-5 lg:px-10 py-1 rounded-lg text-base">{props.status}</button>;
  return button;
}

function ContestButton(props) {
  let button;
  if (props.contest === 1) button = <button className="bg-[#d6ac13] mx-10 lg:ml-20 mt-5 px-20 py-1 rounded-lg text-base animate-pulse">Contest Winner</button>;
  else if (props.contest === 2) button = <button className="bg-[#856d15] mx-10 lg:ml-20 lg:ml-20 mt-5 px-5 lg:px-10 py-1 rounded-lg text-base">Contest Runner-Up</button>;
  else button = <div></div>;
  return button;
}

function Version(props) {
  const [url, setUrl] = useState(null);
  const worldpackRef = ref(storage, `Packs/${props.name}.worldpack`);
  getDownloadURL(worldpackRef).then(url => {
    setUrl(url);
  });
  return (
    <div className="bg-ddg mx-5 lg:mx-0 py-5 mt-5 rounded-lg">
      <p className="text-xl ml-5 fontTitle">{props.name}</p>
      <p className="text-sm ml-5 lg:text-base xl:mr-80">{props.desc}</p>
      <button onClick={() => window.open(url)}className="bg-darkc ml-5 hover:bg-ddc transition duration-50 px-5 py-3 mt-2 rounded-lg text-base">Download</button>
    </div>
  );
}

function User() {

  const [docSnap, setDocSnap] = useState(null);
  const [img, setImg] = useState(<br/>);
  const [imgFound, setImgFound] = useState(false);
  const { packId } = useParams();
  
  async function FindData() {
    let docFound;
    let cacheFound = cache.find(pack => pack.id === packId);
    if (!cacheFound) {
      const docRef = doc(firestore, "Packs", packId);
      docFound = await getDoc(docRef);
      cache.push({
        id: docFound.id,
        data: docFound.data()
      });
      docFound = {
        id: docFound.id,
        data: docFound.data()
      };
    }
    else docFound = cacheFound;
    setDocSnap(docFound);
  }

  if (!docSnap) FindData();

  if (docSnap && docSnap.data.banner && !imgFound) {
    let foundRef = ref(storage, `Images/${docSnap.data.banner}`);
    getDownloadURL(foundRef).then(url => {
      setImg(<img src={url} className="" alt="banner"/>);
      setImgFound(true);
    });
  }

  if (docSnap && !docSnap.data.banner && !imgFound) {
    setImgFound(true);
    setImg(<div><br/></div>);
  }

  if (!docSnap) return (
    <div className="App bg-gradient-to-br from-ddp to-darkp min-h-screen">
      <br/>
      <p className="text-3xl ml-20 mt-20 font-bold">Loading pack...</p>
    </div>
  );

  function FigureOutTags(props) { //inline-grid grid-cols-1 grid-rows-2 md:grid-cols-4 md:grid-rows-1
    const data = props.data;
    if (data.tags.length === 2) return (
      <div className="lg:ml-20 lg:flex">
        <TagButton tag={data.tags[0]}/>
        <TagButton tag={data.tags[1]}/>
      </div>
    );
    else if (data.tags.length === 1) return (
      <div className="lg:ml-20 lg:flex">
        <TagButton tag={data.tags[0]}/>
      </div>
    );
    else return <div></div>;
  }

  let versions = <div></div>;
  docSnap.data["Versions"].forEach(version => {
    versions = <div>
      {versions}
      <Version name={version["Name"]} desc={version["Desc"]} data={docSnap.data}/>
    </div>;
  });

  return (
    <div className="App bg-gradient-to-b from-ddp to-darkp">
      <header className="">
        {img}
        <p className="ml-20 mt-12 text-2xl md:text-4xl lg:text-6xl font-bold fontTitle">
          {docSnap.data.name}
        </p>
      </header>
      <p className="font-bold mt-5 lg:mt-10 text-sm md:text-base lg:text-lg xl:text-xl mx-5 lg:ml-20 lg:mr-16 xl:mr-48">
        By {docSnap.data.creator}
      </p>
      <div className="mt-3 lg:mt-5 text-sm md:text-base lg:text-lg xl:text-xl mx-5 lg:ml-20 lg:mr-16 xl:mr-48">
        {docSnap.data.long}
      </div>
      <FigureOutTags data={docSnap.data} className="ml-16"/>
      <StatusButton status={docSnap.data.status}/>
      <br/>
      <ContestButton contest={docSnap.data.contest}/>
      <br/>
      <div className="mt-10 mb-10 lg:ml-20 lg:mr-32 xl:mr-72">
        {versions}
      </div>
      <button onClick={() => window.location.replace("/")} className="bg-darkc ml-20 mb-20 hover:bg-ddc transition duration-50 px-5 py-3 mt-2 rounded-lg text-base">⇦ Back to search</button>
      <br/>
      <Footer/>
    </div>
  );
}

export default User;